/* 同步 Toast 的状态 */
export const SYNC_TOAST_STATE = 'SYNC_TOAST_STATE';



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js